import { FC } from 'react';
import { Image } from 'src/general/components/Image/Image';

import { IconCircleTickFilled } from 'src/general/Icons/IconCircleTickFilled';
import { BasicModal } from 'src/general/components/BasicModal/BasicModal';
import { Button } from 'src/general/components/Button/Button';
import diagram from './EW-Diagram.png';

import styles from './WarrantyInfoModal.module.scss';

interface WarrantyInfoModalProps {
  isOpen: boolean;
  close?: () => void;
}

export const WarrantyInfoModal: FC<WarrantyInfoModalProps> = ({ isOpen, close }) => (
  <BasicModal
    id="warranty-modal"
    isOpen={isOpen}
    onClose={close}
    title="Carma Extended Coverage"
    className={styles.modal}
  >
    <div className={styles.warrantyModalWrapper}>
      <p>Purchase Carma Extended Coverage and drive with confidence knowing your car is protected.</p>
      <ul className={styles.modalListContainer}>
        <li className={styles.modalListItem}>
          <IconCircleTickFilled className={styles.tickIcon} />
          <div className={styles.modalListContent}>
            <p className={styles.modalListTitle}>Premium mechanical protection</p>
            <p>
              Platinum mechanical protection, equivalent to a new car coverage. With higher claims - up to the purchase
              price of the vehicle.
            </p>
          </div>
        </li>
        <li className={styles.modalListItem}>
          <IconCircleTickFilled className={styles.tickIcon} />
          <div className={styles.modalListContent}>
            <p className={styles.modalListTitle}>Premium Roadside Assist</p>
            <p>Nationwide breakdown help for the life of your coverage. Also includes extra such as a courtesy car. </p>
          </div>
        </li>
        <li className={styles.modalListItem}>
          <IconCircleTickFilled className={styles.tickIcon} />
          <div className={styles.modalListContent}>
            <p className={styles.modalListTitle}>Choice of term</p>
            <p>Choose from either 1, 3 or 5 years coverage.</p>
          </div>
        </li>
      </ul>
      <Image src={diagram} alt="Extended coverage illustration" width={440} height={248} className={styles.diagram} />
      <p>Let us know if you’d like to add Extended Coverage to your purchase, and we’ll take care of the rest.</p>
    </div>
    <div className={styles.modalButtonContainer}>
      <Button variant="primary" size="small" href="/extended-coverage" fullWidth>
        More about Carma Extended Coverage
      </Button>
    </div>
  </BasicModal>
);
